
import { Component, Prop } from 'vue-property-decorator'
import InputWithLabel from '@/commons/components/core/InputWithLabel.vue'
import {
    ApplicationAuthorizedPerson,
    ApplicationDocument
} from '@/commons/types/application'
import { ApplicationUtils } from '@/commons/utils/application'
import {
    validatorIds
} from '@/commons/constants/application'
import { ValidationObserver } from 'vee-validate'
import { translateValidationError } from '@/commons/configuration/vee.validate'
import { ValidationError } from '@/commons/types'
import { ApplicationAuthorizedPersonEntity } from '@/store/entities'

@Component({
    components: { InputWithLabel }
})

export default class AuthorizedPersonDetails extends ValidationObserver {
    @Prop() documentType!: string
    @Prop() authorizedPersonFirstNameField!: string
    @Prop() authorizedPersonLastNameField!: string
    @Prop() authorizedPersonCodeField!: string

    domValidatorIds = validatorIds

    get applicationDocument (): ApplicationDocument {
        return ApplicationUtils.getDocument(this.documentType)
    }

    get authorizedPerson (): ApplicationAuthorizedPerson {
        if (this.applicationDocument.authorizedPerson !== null) {
            return this.applicationDocument.authorizedPerson
        } else {
            return new ApplicationAuthorizedPersonEntity()
        }
    }

    setFirstName (value: string): void {
        this.authorizedPerson.firstName = value || null
    }

    setLastName (value: string): void {
        this.authorizedPerson.lastName = value || null
    }

    setPersonCode (value: string): void {
        this.authorizedPerson.personCode = value || null
    }

    translateError (validationError: ValidationError): string {
        return translateValidationError(validationError)
    }
}
